<template>
    <div>
        <div class="row" style="margin: 20px 0">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="row">
                    <div :class="offsetClass"></div>
                    <div :class="fieldClass">
                        <h1 class="text-primary">Új ügyfél hozzáadása</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="row">
                    <div :class="offsetClass"></div>
                    <div :class="fieldClass">
                        <div v-if="saveError !== null" class="alert alert-danger" role="alert">
                            {{saveError}}
                        </div>
                        <div v-if="saveSuccess" class="alert alert-success" role="alert">
                            Mentés sikeres!
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <form class="form-horizontal" @submit.prevent="save">
                    <div class="row">
                        <div :class="offsetClass"></div>
                        <div :class="fieldClass">
                            <div class="form-group">
                                <label for="name" class="sr-only">Teljes név</label>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    <input
                                        id="name"
                                        type="text"
                                        class="form-control form-control-sm"
                                        v-model="client.name"
                                        placeholder="Teljes név*"
                                        :disabled="isLoading"
                                        required
                                        autofocus
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                        <div :class="offsetClass"></div>
                        <div :class="fieldClass">
                            <div class="form-group">
                                <label for="address" class="sr-only">Cím</label>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    <input
                                        id="address"
                                        type="text"
                                        class="form-control form-control-sm"
                                        v-model="client.address"
                                        placeholder="Cím*"
                                        :disabled="isLoading"
                                        required
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                        <div :class="offsetClass"></div>
                        <div :class="fieldClass">
                            <div class="form-group">
                                <label for="phone" class="sr-only">Telefonszám</label>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    <input
                                        id="phone"
                                        type="text"
                                        class="form-control form-control-sm"
                                        v-model="client.phone"
                                        placeholder="Telefonszám*"
                                        :disabled="isLoading"
                                        required
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                        <div :class="offsetClass"></div>
                        <div :class="fieldClass">
                            <div class="form-group">
                                <label for="email" class="sr-only">E-mail cím</label>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    <input
                                        id="email"
                                        type="text"
                                        class="form-control form-control-sm"
                                        placeholder="E-mail cím*"
                                        v-model="client.email"
                                        :disabled="isLoading"
                                        required
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                        <div :class="offsetClass"></div>
                        <div :class="fieldClass">
                            <div class="form-group">
                                <label for="comment" class="sr-only">Megjegyzés</label>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    <textarea
                                        id="comment"
                                        class="form-control form-control-sm"
                                        placeholder="Megjegyzés"
                                        :disabled="isLoading"
                                        v-model="client.comment"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3"></div>
                    </div>
                    <div class="row" style="padding-top: 1rem">
                        <div :class="offsetClass"></div>
                        <div :class="buttonClass">
                            <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">
                                <i v-if="isLoading" class="fa fa-spin fa-refresh"></i>
                                <i v-else class="fa fa-save"></i>
                                Mentés
                            </button>
                        </div>
                        <div :class="buttonClass">
                            <button v-if="mode === 'pageMode'" type="submit" class="btn btn-primary btn-block" @click.prevent="$router.back()"
                                    :disabled="isLoading">
                                Vissza
                            </button>
                            <button v-else type="submit" class="btn btn-primary btn-block mb-4" @click.prevent="$emit('cancel')"
                                    :disabled="isLoading">
                                Bezárás
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    const pageMode = "pageMode";
    const modalMode = "modalMode";

    export default {
        name: 'NewClient',
        data() {
            return {
                client: {
                    name: '',
                    address: '',
                    phone: '',
                    email: '',
                    comment: ''
                },
                saveSuccess: false
            }
        },
        props: {
            mode: {
                type: String,
                default: pageMode
            }
        },
        computed: {
            saveError(){
                return this.$store.state.ClientModul.error;
            },
            isLoading(){
                return this.$store.state.ClientModul.loading;
            },
            fieldClass(){
                let classes = [
                    'col-lg-12'
                ];
                if(this.mode === pageMode){
                    classes.push('col-xl-6');
                } else {
                    classes.push('col-xl-12');
                }

                return classes;
            },
            offsetClass(){
                if(this.mode === pageMode){
                    return 'col-xl-3';
                } else {
                    return '';
                }
            },
            buttonClass(){
                if(this.mode === pageMode){
                    return 'col-lg-3 col-xl-2';
                } else {
                    return 'col-lg-3';
                }
            }
        },
        methods: {
            save(){
                this.saveSuccess = false;
                this.$store.dispatch('ClientModul/saveClient',
                    {
                        data: this.client,
                        result: res => {
                            let data = res.data;
                            if(data.status == 'ok'){
                                this.client = {
                                    name: '',
                                    address: '',
                                    phone: '',
                                    email: '',
                                    comment: ''
                                };
                                this.saveSuccess = true;
                                if(this.mode === modalMode){
                                    this.$emit('saved', data.id);
                                }
                            }
                        },
                        reject: rej => {

                        }
                    }
                );
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/NewClient.vue